'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$3() {
  this.bgO = null;
  this.bgM = null;
  this.bgN = false;
  this.bgK = null;
  this.bgL = false;
  this.bgP = false;
  this.bgQ = false;
  this.bgO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$3 as $c_Lpresto_PrestoRouter$$anon$3 };
$p = $c_Lpresto_PrestoRouter$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$3;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$3() {
}
export { $h_Lpresto_PrestoRouter$$anon$3 as $h_Lpresto_PrestoRouter$$anon$3 };
$h_Lpresto_PrestoRouter$$anon$3.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bgO;
});
$p.t = (function() {
  if ((!this.bgN)) {
    this.bgM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgN = true;
  }
  return this.bgM;
});
$p.ae = (function() {
  if ((!this.bgL)) {
    this.bgK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bgL = true;
  }
  return this.bgK;
});
$p.w = (function() {
  if ((!this.bgQ)) {
    this.bgP = false;
    this.bgQ = true;
  }
  return this.bgP;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$3, "presto.PrestoRouter$$anon$3", ({
  NV: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$3 as $d_Lpresto_PrestoRouter$$anon$3 };
//# sourceMappingURL=presto.-Presto-Router$$anon$3.js.map
